/** Fields supported by the case-list endpoint. Labels reuse the desktop table. */
export const mobileCaseSortOptions = [
  ['updatedAt', 'lastUpdate'],
  ['createdAt', 'created'],
  ['id', 'id'],
  ['name', 'subject'],
  ['clientFirstName', 'client'],
  ['status', 'status'],
  ['step', 'step'],
  ['agentFirstName', 'agent'],
  ['teamName', 'team'],
  ['workflowName', 'workflow'],
  ['agencyName', 'agency'],
] as const;
